import { useState } from 'react';
import { Formik, Form, Field as FormikField } from 'formik';
import { TextField } from 'formik-mui';
import FormHelperText from '@mui/material/FormHelperText';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Button } from '../shared';

const waitingListFormInitialValues = {
    firstName: '',
    lastName: '',
    contactNumber: '',
    email: '',
};

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const waitingListFormValidationSchema = Yup.object({
    firstName: Yup.string('').required('Name is required'),
    lastName: Yup.string('').required('Surname is required'),
    contactNumber: Yup.string('')
        .matches(phoneRegExp, 'Phone number is not valid')
        .min(9, 'Contact number must contain contain at least 9 characters')
        .max(15, 'Contact number must not contain more than 15 characters')
        .required('Contact number is required'),
    email: Yup.string('').email('Enter a valid email').required('Email is required'),
});

const WaitingListDetailsForm = (props) => {
    const { nextStep, onFormSubmit } = props;
    const [waitingListError, setWaitingListError] = useState(null);

    const onSubmit = async ({ firstName, lastName, contactNumber, email }, { setSubmitting }) => {
        setSubmitting(true);
        try {
            setWaitingListError(null);
            if (onFormSubmit) {
                onFormSubmit({ firstName, lastName, contactNumber, email });
            }
            nextStep();
        } catch (error) {
            setWaitingListError(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={waitingListFormInitialValues}
            validationSchema={waitingListFormValidationSchema}
            onSubmit={onSubmit}
            validateOnBlur
            validateOnChange={false}
        >
            {({ submitForm, isSubmitting, touched, errors, handleChange, handleBlur }) => (
                <Form>
                    <FormikField
                        className="waiting-list-details-form-field"
                        component={TextField}
                        required
                        name="firstName"
                        id="firstName"
                        label="Your Name"
                        variant="outlined"
                        color="secondary"
                        helperText={touched.firstName ? errors.firstName : ''}
                        error={touched.firstName && !!errors.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                    />
                    <br />
                    <FormikField
                        className="waiting-list-details-form-field"
                        component={TextField}
                        required
                        name="lastName"
                        id="lastName"
                        label="Your Surname"
                        variant="outlined"
                        color="secondary"
                        helperText={touched.lastName ? errors.lastName : ''}
                        error={touched.lastName && !!errors.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                    />
                    <br />
                    <FormikField
                        className="waiting-list-details-form-field"
                        component={TextField}
                        required
                        name="contactNumber"
                        id="contactNumber"
                        label="Contact Number"
                        variant="outlined"
                        color="secondary"
                        helperText={touched.contactNumber ? errors.contactNumber : ''}
                        error={touched.contactNumber && !!errors.contactNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                    />
                    <br />
                    <FormikField
                        className="waiting-list-details-form-field"
                        component={TextField}
                        required
                        name="email"
                        id="email"
                        type="email"
                        label="Email"
                        variant="outlined"
                        color="secondary"
                        helperText={touched.email ? errors.email : ''}
                        error={touched.email && !!errors.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                    />
                    <br />
                    <FormHelperText error>{waitingListError}</FormHelperText>
                    <Button
                        id="waiting-list-details-form-next-button"
                        className="waiting-list-details-form-button"
                        variant="contained"
                        color="primary"
                        isLoading={isSubmitting}
                        onClick={submitForm}
                    >
                        Next
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default WaitingListDetailsForm;

WaitingListDetailsForm.propTypes = {
    nextStep: PropTypes.func,
    onFormSubmit: PropTypes.func,
};
